/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { SetStateAction, useState, Dispatch } from "react";
import { Box, Button, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import CustomerDocumentModal from "../../Modals/customerDocument";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";
import moment from "moment";
import CustomToggle from "../../helpers/CustomToggle";
import { useUpdateUserMutation } from "../../services/customer";
import { showToast, showError } from "../../constants/toasts";
import Chip from "../../components/Chip";
import { CHIP_COLORS } from "../../constants/chipColors";
import ApproveButton from "../../components/ApproveButton";
import { useDeleteSupportMutation } from "../../services/customerSupport";
interface BookingListProps {
  userData: any;
  setOpen1: Dispatch<SetStateAction<boolean>>;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setSelectedIdUser: Dispatch<SetStateAction<string>>;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  totalCount: number;
  page: any;
  handlePageChange: any;
  handleStatusUpdate: any;
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const BookingList: React.FC<BookingListProps> = ({
  userData,
  setOpen1,
  setSelectedId,
  setSelectedIdUser,
  totalCount,
  page,
  handlePageChange,
  handleStatusUpdate,
  setDebouncedSearchTerm,
  searchTerm,
  setSearchTerm,
}) => {
  const rows = userData;
  const navigate = useNavigate();
  const [updateUser] = useUpdateUserMutation();
  const [userDataState, setUserDataState] = useState(userData);
 

  React.useEffect(() => {
    setUserDataState(userData);
  }, [userData]);

  const label = { inputProps: { "aria-label": "Switch demo" } };



  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "firstName",
      headerName: "Name",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const { row } = params;
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate(`/manage-user/detail/${row._id}`)}
          >
            <figure>
              <img
                src={
                  row.image && row.image !== "string"
                    ? row.image
                    : "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{row.firstName || row?.name}</b> <span>{row.email}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "address",
      headerName: "Address",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const { row } = params;
        const address = [
          row.addressLineOne,
          row.addressLineTwo,
          row.city,
          row.state,
          row.country,
          row.zipCode,
        ]
          .filter(Boolean)
          .join(", ");
        return <span>{address || "-"}</span>;
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "isEmailVerified",
      headerName: "Email Verified",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const { row } = params;
        return row.isEmailVerified ? (
          <Chip
            label="Verified"
            color={CHIP_COLORS.SUCCESS.color}
            backgroundColor={CHIP_COLORS.SUCCESS.backgroundColor}
          />
        ) : (
          <Chip
            label="Not Verified"
            color={CHIP_COLORS.ERROR.color}
            backgroundColor={CHIP_COLORS.ERROR.backgroundColor}
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "phoneNumber",
      headerName: "Phone Number",
      editable: false,
      sortable: false,
      renderCell: (params) => <span>{params.row.phoneNumber || "-"}</span>,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "isPhoneVerified",
      headerName: "Phone Verified",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const { row } = params;
        return row.isPhoneVerified ? (
          <Chip
            label="Verified"
            color={CHIP_COLORS.SUCCESS.color}
            backgroundColor={CHIP_COLORS.SUCCESS.backgroundColor}
          />
        ) : (
          <Chip
            label="Not Verified"
            color={CHIP_COLORS.ERROR.color}
            backgroundColor={CHIP_COLORS.ERROR.backgroundColor}
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "createdAt",
      headerName: "Created At",
      editable: false,
      sortable: false,
      renderCell: (params) => (
        <span>
          {params.row.createdAt
            ? moment(params.row.createdAt).format("YYYY-MM-DD HH:mm")
            : "-"}
        </span>
      ),
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const { row, id } = params;
        const index = userDataState.findIndex((u: any) => u._id === row._id);
        return (
          <CustomToggle
            checked={!row?.isBlocked}
            onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
            id={row?._id} // size="small"
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const { row } = params;
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => navigate(`/manage-user/detail/${row._id}`)}
              >
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => navigate(`/manage-customers/edit/${row._id}`)}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setOpen1(true);
                  setSelectedId(row?._id);
                  setSelectedIdUser(row?._id);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);

  const handleCloseModal = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="sorting_table">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() =>
                navigate("/manage-customers/add", { state: { tab: 0 } })
              }
            >
              <AddIcon />
              Add
            </Button>
          </div>
        </div>
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={userDataState}
          count={totalCount}
          page={page}
          onPageChange={handlePageChange}
        />
      </div>

      <CustomerDocumentModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
    </>
  );
};

export default BookingList;
